import React from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import { ThemeTab } from './ThemeTab';

/**
 * Theme Settings Page
 * Dedicated page for custom theme configuration
 */
const ThemePage: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Custom Theme"
        description="Customize the appearance and branding of your partner dashboard"
      />
      <ThemeTab />
    </div>
  );
};

export default ThemePage;
